var exports = {
  "I": "withAvatar__zlZctL",
};

module.exports = exports;
